import { Button, ButtonProps } from "@mui/material";

export const PrimaryButton = (props: ButtonProps) => <Button variant="contained" color="primary" {...props} />;
export const SecondaryButton = (props: ButtonProps) => <Button variant="contained" color="secondary" {...props} />;
export const TertiaryButton = (props: ButtonProps) => <Button variant="outlined" color="primary" {...props} />;
export const LinkButton = (props: ButtonProps) => <Button variant="text" color="primary" {...props} />;